import { ApolloQueryResult } from 'apollo-client';

import { addDialogMutation } from '../../graphql/mutations/grid/dialogs';
import {
    AddDialogMutation,
    AddDialogMutation_addDialog_validationResult,
    GdAddDialogRequestInput
} from '../../typings/graphql-grid';
import { BaseMutationExecutor } from '../BaseMutationExecutor/BaseMutationExecutor';

export type DialogsApiDataResult = {
    validationResult: AddDialogMutation_addDialog_validationResult | null;
};

export class DialogsMutationExecutor extends BaseMutationExecutor {
    public async addDialog(
        login: string,
        input: GdAddDialogRequestInput
    ): Promise<DialogsApiDataResult> {
        return this.client
            .awaitMutate<AddDialogMutation>({
                mutation: addDialogMutation,
                variables: {
                    input
                },
                login
            })
            .then((result: ApolloQueryResult<AddDialogMutation>) => {
                return {
                    validationResult: result.data.addDialog.validationResult
                };
            });
    }
}
